import React from "react";
import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Constants
import { pathHomePage } from "../../../../config/constants";
//Components
import { FooterContainer, SubmitDiv, ContinueButton, CancelButton } from "./styles";

const Footer = ({ handleSubmit }) => {
  const clinicianData = useSelector(({ clinician }) => clinician.data);
  const [t] = useTranslation("global");

  return (
    <FooterContainer>
      <SubmitDiv>
        <ContinueButton onClick={handleSubmit}>{t("addPatient.createButton")}</ContinueButton>
        <CancelButton to={`${pathHomePage}/home/${clinicianData.token}`}>{t("addPatient.cancelButton")}</CancelButton>
      </SubmitDiv>
    </FooterContainer>
  );
};

export default Footer;
